import {
  CalendarMonthOutlined,
  ScheduleOutlined,
  EventNoteOutlined,
  CardGiftcardOutlined,
  StarBorderOutlined,
  ReceiptLongOutlined,
  WarningAmberOutlined,
  SavingsOutlined,
  PauseCircleOutline,
  TuneOutlined,
} from "@mui/icons-material";

// Configuration navigation and backend pay input identifiers.
export const PAY_INPUT_CONFIG_ITEMS = [
  { key: "shift-earnings", label: "Shift Earnings", apiType: "SHIFT_EARNING", icon: CalendarMonthOutlined },
  { key: "overtime", label: "Overtime", apiType: "OVERTIME", icon: ScheduleOutlined },
  { key: "leave", label: "Leave", apiType: "LEAVE", icon: EventNoteOutlined },
  { key: "incentives", label: "Incentives", apiType: "INCENTIVE", icon: CardGiftcardOutlined },
  { key: "bonus", label: "Bonus", apiType: "BONUS", icon: StarBorderOutlined },
  { key: "reimbursements", label: "Reimbursements", apiType: "REIMBURSEMENT", icon: ReceiptLongOutlined },
  { key: "penalties", label: "Penalties", apiType: "PENALTY", icon: WarningAmberOutlined },
  { key: "loans-and-advances", label: "Loans & Advances", apiType: "LOAN_ADVANCE", icon: SavingsOutlined },
  { key: "salary-hold", label: "Salary Hold", apiType: "SALARY_HOLD", icon: PauseCircleOutline },
  { key: "payroll-adjustments", label: "Payroll Adjustments", apiType: "PAYROLL_ADJUSTMENT", icon: TuneOutlined },
  { key: "damage-and-recovery", label: "Damage & Recovery", apiType: "DAMAGE_RECOVERY", icon: WarningAmberOutlined },
  { key: "security-deposit", label: "Security Deposit", apiType: "SECURITY_DEPOSIT", icon: SavingsOutlined },
];

export const DEFAULT_PAY_INPUT_CONFIG_KEY = PAY_INPUT_CONFIG_ITEMS[0].key;

export const APPROVAL_OPTIONS = [
  { value: "no", label: "No" },
  { value: "yes", label: "Yes" },
];

export const approvalHelperText = (label, approvalRequired) =>
  approvalRequired === "yes"
    ? `Currently set to Yes. ${label} entries must be approved before they are included in payroll.`
    : `Currently set to No. ${label} will be included in payroll without approval.`;

export const validatePayInputConfig = (config) =>
  config.sources.length === 0
    ? { sources: "Select at least one source." }
    : {};

export const isSameConfig = (a, b) =>
  a.enabled === b.enabled &&
  a.treatment === b.treatment &&
  a.approvalRequired === b.approvalRequired &&
  a.rounding === b.rounding &&
  a.sources.length === b.sources.length &&
  a.sources.every((source) => b.sources.includes(source));
